import Rail from "./Rail";
import Slider from "./Slider";

export * from "./Slider";
export * from "./Rail";

export default class SliderInstance extends Slider {
    static Rail = Rail;
}


// WEBPACK FOOTER //
// ./src/components/Slider/index.tsx